(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kex-base"] && !Shopify.designMode) return;
  try {
    
  class KEXPhotoWall extends HTMLElement {
    connectedCallback() {
      if (this.dataset.activateOnScroll !== 'true') {
        this.classList.add('is-active');
        return;
      }

      if (!('IntersectionObserver' in window)) {
        this.classList.add('is-active');
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('is-active', entry.isIntersecting && entry.intersectionRatio > 0.35);
        });
      }, { threshold: [0, 0.35, 0.55] });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  if (!customElements.get('kex-base-photo-wall')) {
    customElements.define('kex-base-photo-wall', KEXPhotoWall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kex-shop-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.kexShopCollectionsLoaded) return;
    window.kexShopCollectionsLoaded = true;

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-tab]');
      if (tab) {
        const section = tab.closest('[data-shop]');
        if (!section) return;

        const id = tab.getAttribute('data-tab');
        section.querySelectorAll('[data-tab]').forEach((button) => {
          const active = button === tab;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        section.querySelectorAll('[data-panel]').forEach((panel) => {
          panel.hidden = panel.getAttribute('data-panel') !== id;
        });

        const subtitle = section.querySelector('[data-tab-subtitle]');
        if (subtitle) subtitle.textContent = tab.getAttribute('data-subtitle') || '';
        return;
      }

      const scrollButton = event.target.closest('[data-scroll]');
      if (!scrollButton) return;

      const section = scrollButton.closest('[data-shop]');
      const activePanel = section ? section.querySelector('[data-panel]:not([hidden])') : null;
      const slider = activePanel ? activePanel.querySelector('[data-slider]') : null;
      if (!slider) return;

      const direction = Number(scrollButton.getAttribute('data-scroll')) || 1;
      slider.scrollBy({ left: direction * slider.clientWidth * 0.82, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
